import { Reservation } from "./reservation";
import { RoomCategory } from "./roomCategory";

export enum RoomType {
  SINGLE = "SINGLE",
  DOUBLE = "DOUBLE",
  SUITE = "SUITE",
  DELUXE = "DELUXE",
  PRESIDENTIAL = "PRESIDENTIAL",
}

export enum RoomStatus {
  AVAILABLE = "AVAILABLE",
  OCCUPIED = "OCCUPIED",
  BOOKED = "BOOKED",
  OUT_OF_SERVICE = "OUT_OF_SERVICE",
}

export interface Room {
  id: string;
  number: number;
  type: RoomType;
  status: RoomStatus;
  floor: number;
  area?: number | string | null;
  hotelId: string;
  photoId: string;

  createdAt: string;
  updatedAt: string;
  reservations?: Reservation[];
  category?: RoomCategory;
  categoryId?: string;
}

export interface RoomWithReservationsData extends Room {
  previousBooking: Reservation | null;
  currentBooking: Reservation | null;
  nextBooking: Reservation | null;
}

export interface RoomResponse {
  data: Room[];
  total: number;
  page: number;
  limit: number;
}

export interface CreateRoomRequest {
  number: string;
  categoryId: string;
  status: RoomStatus;
  area: string;
  floor: string;
  photoId?: string;
  hotelId: string;
}

export interface UpdateRoomRequest {
  number?: number;
  type?: RoomType;
  status?: RoomStatus;
  floor?: number;
  area?: number | string;
  amenities?: string[];
  photoId?: string | null;
  categoryId?: string;
}

export interface RoomFilters {
  categoryId?: string;
  status?: string;
  floor?: number;
  hotelId?: string;
  amenities?: string[];
  sort?: string;
  sortBy?: string;
  sortOrder?: "asc" | "desc";
  page?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  hasActualBookings?: boolean;
}
